import React from 'react'

import { Stack, Typography } from '@pnld/components-web'

type ErrorLogSection = {
  // Posição do trecho no log: única por seção, serve de key.
  offset: number
  label: string
  text: string
}

// "[rótulo] texto [rótulo] texto".
export const parseErrorLog = (errorLog: string): ErrorLogSection[] => {
  // Sticky: só casa na posição dada. Quem procura o próximo "[" é o laço, e
  // não o motor de regex, que repetiria a tentativa em cada "[" do texto.
  const section = /\[([^\]]+)\]\s*([^[\s][^[]*)/y
  const sections: ErrorLogSection[] = []
  let start = errorLog.indexOf('[')
  while (start !== -1) {
    section.lastIndex = start
    const match = section.exec(errorLog)
    if (match) {
      sections.push({
        offset: start,
        label: match[1].trim(),
        text: match[2].trim(),
      })
      start = errorLog.indexOf('[', section.lastIndex)
    } else {
      // Todo "[" antes do próximo "]" fecha nele e falharia do mesmo jeito.
      const close = errorLog.indexOf(']', start + 1)
      if (close === -1) break
      start = errorLog.indexOf('[', close + 1)
    }
  }
  return sections
}

export const ErrorLogContent: React.FC<{ errorLog: string | null }> = ({
  errorLog,
}) => {
  if (!errorLog) {
    return (
      <Typography variant="b-lg">Ops! Não há detalhes disponíveis.</Typography>
    )
  }

  const sections = parseErrorLog(errorLog)

  return (
    <Stack spacing={4}>
      {sections.length > 0 ? (
        sections.map(section => (
          <Stack key={section.offset} spacing={1}>
            <Typography variant="s-sm">[{section.label}]</Typography>
            <Typography variant="b-lg">{section.text}</Typography>
          </Stack>
        ))
      ) : (
        <Typography variant="b-lg">{errorLog}</Typography>
      )}
    </Stack>
  )
}
